import { useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { AvailableDocumentGroup } from '../../../interfaces/AvailableDocumentGroup';
import AvailableDocumentsGroup from './AvailableDocumentsGroup';

export interface DescriptionLinkModalProps { }

const AvailableDocumentsModal: FC<DescriptionLinkModalProps> = () => {
  const groups: AvailableDocumentGroup[] = useScopedSelector('/App.features.documents.available');

  if (!groups) return null;

  return (
    <>
      {groups.map((group) => <AvailableDocumentsGroup key={group.type} group={group}></AvailableDocumentsGroup>)}
    </>
  );
};
export default AvailableDocumentsModal;
